<template>
    <div class="message-thread">
        <button v-if="allowAttendeeVideo && !isStarted"
                @click="startVideo"
                title="Start video" class="btn btn-info pull-right"
                style="margin-top: -10px;"
                >
            <span><i class="icon-facetime-video icon-white"></i> Video chat now</span>
        </button>

        <MessageTitle
            :message="thread" 
            :me="me"
            :url="pageUrl" 
            :long="true"
        />

        <div v-for="related in relatedThreads" :key="related.room" in class="related-thread">
            Related chat: 
            <router-link
                :to="{ name: 'message-thread', params:{ threadId: related.room } }"
            >{{buildThreadTitle(related, me.id, true)}}</router-link>
        </div>
        <!-- <a v-if="pageUrl"
            :href="pageUrl" title="Link to page"
            class="message-thread-banner"
        >
            <MessageTitle v-if="thread" 
                :message="thread" 
                :me="me"
                :url="pageUrl" />
        </a>
        <div v-else>
            <MessageTitle v-if="thread" :message="thread" :me="me" />
        </div> -->

        <VideoJitsi v-if="allowAttendeeVideo && isStarted"
            @closed="doVideoStop"
            :attendee_id="otherAttendeeId"
            :start_now="true"
        />

        <RestrictedHeight v-if="thread">
            <ChatSocketComponent
                :room="roomName"
                :timezone="timezone"
            />
        </RestrictedHeight>
        <div v-else>
            Sorry, no chat available for this message thread yet.
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ChatSocketComponent from "@/components/chat/ChatSocketComponent";
import MessageTitle from "@/components/message/MessageTitle";
import RestrictedHeight from "@/components/RestrictedHeight";
import VideoJitsi from "@/components/VideoJitsi";
import {buildThreadTitle} from "@/utils/Message";

export default {
    name: "Thread",
    components: {
        ChatSocketComponent,
        MessageTitle,
        RestrictedHeight,
        VideoJitsi,
    },
    data() {
        return {
            isStarted: false,
        }
    },
    props: {
        timezone: {
            type: String,
            required: true,
        },
    },
    computed: {
        /* Link out to the appropriate Appointment/Attendee/Meeting */
        pageUrl() {
            if (this.thread && this.me) {
                if (this.thread.meeting_id) {
                    return `/book/show?id=${this.thread.meeting_id}`;
                }
                if (this.thread.appointment_id) {
                    return `/appointments/${this.thread.appointment_id}`;
                }
                if (this.me.id == this.thread.sender_id) {
                    if (this.thread.attendee_id) {
                        return `/search/attendees?id=${this.thread.attendee_id}`;
                    }
                } else {
                    if (this.thread.sender_id) {
                        return `/search/attendees?id=${this.thread.sender_id}`;
                    }
                }
            }
            return null;
        },
        thread() {
            return this.threadCache(this.$route.params.threadId);
        },
        relatedThreads() {
            if (!this.otherAttendeeId) { return []; }
            const threads = [];
            this.roomsByAttendeeId(this.otherAttendeeId).forEach(room => {
                if (room != this.thread.room) {
                    threads.push(this.threadCache(room));
                }
            });
            return threads;
        },
        roomName() {
            if (this.thread) {
                return this.thread.room;
            } else {
                return null;
            }
        },
        otherAttendeeId() {
            if (this.thread && this.me) {
                // if (this.thread.meeting_id || this.thread.appointment_id) {
                if (this.thread.appointment_id) {
                    return null;
                } else if (this.thread.meeting) {
                    if (this.thread.meeting.booker_id != this.me.id) { return this.thread.meeting.booker_id; }
                    if (this.thread.meeting.attendee_id != this.me.id) { return this.thread.meeting.attendee_id; }
                } else {
                    if (this.me.id == this.thread.sender_id) {
                        return this.thread.attendee_id;
                    } else {
                        return this.thread.sender_id;
                    }
                }
            }
            return null;
        },
        isJitsi() {
            return this.getSetting('VIDEO_PROVIDER_JITSI');
        },
        allowAttendeeVideo() {
            return this.isJitsi && this.otherAttendeeId && this.getSetting('VIDEO_ATTENDEE_ENABLED');
        },
        ...mapGetters({
            me: 'currentAttendee',
            threadCache: 'messages/threadCache',
            threadById: 'messages/threadById',
            roomsByAttendeeId: 'messages/roomsByAttendeeId',
            getSetting: 'me/getSetting',
        })
    },
    methods: {
        buildThreadTitle,
        handleNewMessage(chatMsg) {
            this.$store.dispatch('messages/newMessage', chatMsg);
        },
        startVideo() {
            this.isStarted = true;
        },
        doVideoStop() {
            this.isStarted = false;
        }
    }
}
</script>

<style>
.message-thread {
    margin-top: 10px;
}

.message-thread-banner {
    text-decoration: none;
    color: #333;
}

.message-thread-banner:hover .message-title-hover-hint { /* Inside knowledge on MessageTitle element */
    display: inline-block;
}
</style>
